import { atom } from 'jotai';

import { IActionMetadata } from './policy.atoms';

export const actionsMetadataMapping = atom<Record<number, IActionMetadata>>({});
